import type { ReactNode } from 'react';

import { cn } from '@/utils/cn';

interface CardProps {
  children: ReactNode;
  className?: string;
}

export const Card = ({ children, className }: CardProps) => (
  <div className={cn('rounded-xl border border-slate-100 bg-white shadow-card', className)}>
    {children}
  </div>
);
